'use client';

import { useEffect, useRef } from 'react';

//* Styles
import ServiceTemplateIndividualStyle from './style';

//* Components
import Text from '@/components/Text';
import ServiceItem from '../ServiceItem';
import HeroIndividualService from '../Hero';
import Container from '@/components/Container';
import useTrigger from '@/components/Animation/useTrigger';
import ServiceSection from '@/modules/_section/ServiceSection';
import TextAnimation from '@/components/Animation/TextAnimation/TextAnimation';

const ServiceTemplateIndividual = ({ data, heroData }) => {
	const wrapperRef = useRef();
	const titleRef = useRef();

	useEffect(() => {
		const trigger = useTrigger({
			ref: wrapperRef.current,
			documentPercent: 60,
			onEnter: () => {
				[...wrapperRef.current.children].forEach((item) => {
					item.classList.add('active');
				});
			},
		});

		const newTrigger = useTrigger({
			ref: titleRef.current,
			documentPercent: 80,
			onEnter: () => {
				titleRef.current.children[0].classList.add('active');
			},
		});

		return () => {
			trigger();
			newTrigger();
		};
	}, []);

	return (
		<ServiceTemplateIndividualStyle>
			<HeroIndividualService {...heroData} />
			<Container isSection>
				<Text
					ref={titleRef}
					tag={'h1'}
					className={'title font-montserrat-arm-medium h3 text-primary-color'}>
					<TextAnimation text={data.title} />
				</Text>

				<div className='outside-wrapper-items'>
					<div
						ref={wrapperRef}
						className='wrapper-items'>
						{data.description.map((item, i, arr) => {
							return (
								<div
									className='wrapper-services'
									style={{ '--delay': i, '--itemsCount': arr.length }}
									key={i}>
									<ServiceItem
										delay={i}
										itemsCount={arr.length}
										className={`${i % 2 ? 'translateMinus' : 'translatePlus'} animate`}
										{...item}
									/>
								</div>
							);
						})}
					</div>
				</div>
			</Container>

			<ServiceSection hideItem={data.url} />
		</ServiceTemplateIndividualStyle>
	);
};

export default ServiceTemplateIndividual;
